import { Skeleton } from '~/chords/Skeleton';

export function TableCellSkeletonHasActions() {
  return (
    <div className="h-2xl w-2xl">
      <Skeleton />
    </div>
  );
}

TableCellSkeletonHasActions.displayName = 'TableCellSkeletonHasActions';
